module.exports = __webpack_public_path__ + "static/DM03-1b194e3caab2304a2a00d6380d1fd352.jpg";